import { Box, Button, Grid2, List, ListItem, Paper, Popover, Typography } from '@mui/material'
import { convertToPixelFromVH, convertToPixelFromVW } from '../../utils/ViewportUtils';
import { useContext, useState } from 'react'

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { KPIContext } from '../../contexts/kpiContext';
import { KPI_REPORTING_FILTERS } from '../../constants/KPIReportingFiltersConstants';
import React from 'react';
import { SCROLL_BAR_STYLE_PROPS } from '../../constants/ScrollbarProps';
import { ViewportContext } from '../../contexts/viewportContext';

function SiteNamesSelect({ defaultValues, siteNamesChangedFn }
    : { defaultValues: string[], siteNamesChangedFn: (values: string[]) => void }) {

    const kpiContext = useContext(KPIContext);
    const vpContext = useContext(ViewportContext);

    const availableSiteNames = [...KPI_REPORTING_FILTERS.SITE_NAMES_ASR, ...KPI_REPORTING_FILTERS.SITE_NAMES_JV];
    const [tempSites, setTempSites] = useState<string[]>([...defaultValues]);

    const allSitesSelected = () => tempSites.length === availableSiteNames.length;
    const handleSelectAll = () => setTempSites([...availableSiteNames]);
    const handleClearAll = () => setTempSites([])
    const applySiteNames = () => {
        setSiteNameAnchorEl(null)
        siteNamesChangedFn([...tempSites]);
    }
    const isSelected = (site: any) => {
        console.log(tempSites, site)
        return tempSites.includes(site)
    };
    const toggleSite = (site: any) => {
        if (!tempSites.includes(site))
            setTempSites(previous => [...previous, site]);
        else
            setTempSites(previous => previous.filter(s => s !== site));
    }

    const [siteNameAnchorEl, setSiteNameAnchorEl] = useState<HTMLButtonElement | null>(null);
    const siteNameExpanded = Boolean(siteNameAnchorEl);
    const siteNameId = siteNameExpanded ? 'site-name-popover' : undefined;

    const handleSiteNameClosed = () => {
        setSiteNameAnchorEl(null);
    };
    const handleSiteNameClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setSiteNameAnchorEl(event.currentTarget);
    };

    return (
        <Grid2 container
            sx={{
                width: { xs: "100%" },
                display: 'flex',
                flexDirection: "column",
                alignItems: 'center',
                gap: 1,
                position: 'relative',
            }}>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: "column",
                alignItems: 'center',
            }}>
                <Button
                    disableRipple
                    variant='outlined'
                    onClick={handleSiteNameClick}
                    sx={{
                        color: 'var(--text-dark)',
                        width: '75%',
                        background: 'var(--text-light)',
                        boxSizing: 'border-box',
                        paddingY: 1.125,
                        paddingX: 2,
                        borderRadius: '1vw',
                        border: 'none',
                        zIndex: 100,
                        textTransform: 'capitalize',
                        textAlign: 'left'
                    }}>
                    <Typography width={'100%'}>
                        {
                            kpiContext?.state.filters.siteName.length === availableSiteNames.length
                                ? 'All Sites' : `Selected Sites(${kpiContext?.state.filters.siteName.length})`
                        }
                    </Typography>
                    {siteNameExpanded ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
                </Button>
                {/* <Box sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: "row",
                    alignItems: 'center',
                    gap: 2,
                }}>
                    
                </Box> */}
            </Box>
            <Popover
                id={siteNameId}
                open={siteNameExpanded}
                anchorEl={siteNameAnchorEl}
                onClose={handleSiteNameClosed}
                hideBackdrop={false}
                closeAfterTransition={false}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                sx={{
                    width: '100%',
                    height: 'auto',
                    '& .MuiPopover-paper': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        filter: 'drop-shadow(0 0 2px #0090B3)'
                    },
                }}
            >
                <Paper
                    sx={{
                        width: '17.5vw',
                        padding: 2,
                        boxSizing: 'border-box',
                        clipPath: `path('M 0 0 H ${convertToPixelFromVW(16.5)} L ${convertToPixelFromVW(17.5)} ${convertToPixelFromVH(1.5)} V ${convertToPixelFromVH(40)} H 0 Z')`,
                    }}>
                    {availableSiteNames.length > 0 && <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        <Button variant='text'
                            onClick={allSitesSelected() ? handleClearAll : handleSelectAll}
                            sx={{
                                color: '#00A9B1',
                                fontWeight: 700,
                                textDecoration: 'underline',
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}>
                            {allSitesSelected() ? 'Clear All' : 'Select All'}
                        </Button>
                        <Button variant='contained'
                            onClick={applySiteNames}
                            sx={{
                                color: 'var(--text-light)',
                                fontWeight: 700,
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}>
                            Apply
                        </Button></Box>}
                    <List sx={{
                        height: convertToPixelFromVH(vpContext?.is4k ? 30 : 25),
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                        gap: 1,
                        ...SCROLL_BAR_STYLE_PROPS,
                    }}>
                        {availableSiteNames.map((site: string) => {
                            return (
                                <ListItem
                                    key={site}
                                    sx={{
                                        width: '97.5%',
                                        paddingX: 1,
                                        paddingY: 0.5,
                                        display: 'inline-block',
                                    }}>
                                    <Button
                                        onClick={() => toggleSite(site)}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            paddingX: 0,
                                            lineHeight: 1,
                                            textAlign: 'left',
                                            '& svg': {
                                                fill: 'url(#bookmark_feedback_elements_gradient)',
                                                marginRight: 1,
                                            }
                                        }}>
                                        {isSelected(site) ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                                        <Typography variant='body1' component={'p'}>
                                            {site}
                                        </Typography>
                                    </Button>
                                </ListItem>
                            )
                        })}
                    </List>
                </Paper>
            </Popover>
        </Grid2>
    )
}

export default React.memo(SiteNamesSelect)